import React from 'react';
import styled from 'styled-components';
import { HeadlineOne, Paragraph } from 'components/atoms/SectionWrapper.style';
import { cms } from 'assets/cms';

export const EditHeadlineOne = styled(HeadlineOne)`
  font-size: 35px;
  margin-top: 80px;
  text-align: center;
`;
export const EditParagraph = styled(Paragraph)`
  font-size: 20px;
  margin-top: 0;
  justify-content: flex-start;
  span {
    color: green;
    font-size: 25px;
    font-weight: 700;
  }
`;

const BenefitsPv = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
`;

export const BenefitsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  @media ${({ theme }) => theme.media.tablet} {
    flex-wrap: wrap;
    div {
      width: 40%;
    }
  }

  @media ${({ theme }) => theme.media.laptop} {
    flex-wrap: wrap;
    div {
      width: 25%;
      margin: 35px;
    }
  }

  div {
    margin: 25px;
    img {
      height: 50px;
      margin-bottom: 15px;
    }
  }
`;

const Benefits = () => (
  <>
    <BenefitsPv>
      <EditHeadlineOne>
        Jakie korzyści daje fotowoltaika w <br />
        domu i firmie
      </EditHeadlineOne>
      <EditParagraph>
        Zastanawiasz się nad inwestycją w fotowoltaikę? Poznaj wszystkie
        korzyści,
        <br /> jakie zapewnia instalacja fotowoltaiczna.
      </EditParagraph>
      <BenefitsWrapper>
        <div>
          <img src={cms.icons.money} />
          <EditParagraph>
            <span>Zmniejszenie rachunków za prąd</span>
          </EditParagraph>
          <EditParagraph>
            Darmowy prąd? To brzmi dobrze! W domu czy pracy, energia elektryczna
            jest niezbędna do normalnego funkcjonowania. Teraz możesz mieć ją za
            darmo dzięki fotowoltaice. Ogniwa fotowoltaiczne wraz z inwerterem
            zamieniają promienie słońca na czystą energię, z której możesz
            korzystać w swoich gniazdkach.
          </EditParagraph>
        </div>
        <div>
          <img src={cms.icons.power2} />
          <EditParagraph>
            <span>Niezależność energetyczna</span>
          </EditParagraph>
          <EditParagraph>
            Mieszkasz w miejscu, w którym nie ma sieci energetycznej?
            Dotychczasowym rozwiązaniem był agregat prądotwórczy? Teraz jego
            alternatywą jest instalacja fotowoltaiczna. Samowystarczalna, o mocy
            z zapasem zabezpieczającej Twoje potrzeby energetyczne, bezpieczna i
            bezobsługowa.
          </EditParagraph>
        </div>
        <div>
          <img src={cms.icons.leaf} />
          <EditParagraph>
            <span>Odpowiedzialność ekologiczna</span>
          </EditParagraph>
          <EditParagraph>
            Świadomość proekologiczna w społeczeństwie jest coraz większa.
            Ochrona środowiska może być realizowana na wielu płaszczyznach.
            Ograniczenie zużycia prądu produkowanego w elektrowniach węglowych,
            to jedno z działań, które warto podjąć. Instalacja fotowoltaiczna
            pozwala to zrobić szybko i sprawnie.
          </EditParagraph>
        </div>
        <div>
          <img src={cms.icons.fire} />
          <EditParagraph>
            <span>Darmowe ogrzewanie</span>
          </EditParagraph>
          <EditParagraph>
            Fotowoltaika może być wykorzystana do ekologicznego ogrzewania
            pomieszczeń i budynków. Prąd uzyskany dzięki instalacji PV może
            zasilać elektryczne ogrzewanie podłogowe, promienniki podczerwieni
            lub pompę ciepła. Latem prąd może służyć do zasilania klimatyzacji.
          </EditParagraph>
        </div>
        <div>
          <img src={cms.icons.paperMoney} />
          <EditParagraph>
            <span>Inwestycja z dopłatą od państwa</span>
          </EditParagraph>
          <EditParagraph>
            Obecnie funkcjonuje kilka programów dopłat, pozwalających
            zainstalować fotowoltaikę w niższej cenie. Dopłaty do instalacji
            fotowoltaicznych mogą sięgać nawet kilkudziesięciu procent, czyniąc
            tę inwestycję jeszcze bardziej dostępną i opłacalną. Pomagamy w
            zdobyciu dofinansowania na ten cel.
          </EditParagraph>
        </div>
        <div>
          <img src={cms.icons.recycling} />
          <EditParagraph>
            <span>Nieograniczone możliwości</span>
          </EditParagraph>
          <EditParagraph>
            Instalacje fotowoltaiczne można w przyszłości rozbudowywać, tak aby
            zabezpieczały coraz większe potrzeby energetyczne. Ogniwa
            fotowoltaiczne (panele solarne), mogą być instalowane nie tylko na
            dachach, ale również specjalnych konstrukcjach stalowych mocowanych
            do gruntu.
          </EditParagraph>
        </div>
      </BenefitsWrapper>
    </BenefitsPv>
  </>
);

export default Benefits;
